import React from 'react'
import algoliasearch from 'algoliasearch'
import { compose, reduce, sortBy } from 'ramda'

const { REACT_APP_ALGOLIA_APP_ID, REACT_APP_ALGOLIA_API_KEY } = process.env

export const initIndex = (index) => algoliasearch(REACT_APP_ALGOLIA_APP_ID, REACT_APP_ALGOLIA_API_KEY).initIndex(index)

export const withAlgoliaClient = (Comp) => {
  const algoliaProps = {
    algoliaClient: initIndex(process.env.REACT_APP_ALGOLIA_INDEX_NAME)
  }
  return props => <Comp {...props} {...algoliaProps} />
}

export const mergeHtmlByRanking = compose(
  reduce(
    (acc, article) => {
      return {
        ...acc,
        ...article,
        html: acc.html.concat(article.html)
      }
    }, { html: '' }
  ),
  sortBy(article => article.custom_ranking.position)
)
